export default {

  land: [
    {
      "x": 0
    },
    {
      "x": -26.28
    },
    {
      "x": -28.73
    },
    {
      "x": -34.41
    },
    {
      "x": -40.88
    },
    {
      "x": -48.13
    },
    {
      "x": -54.55
    },
    {
      "x": -60.94
    },
    {
      "x": -67.3
    },
    {
      "x": -74.42
    },
    {
      "x": -80.73
    },
    {
      "x": -87.01
    },
    {
      "x": -94.04
    },
    {
      "x": -100.27
    },
    {
      "x": -106.46
    },
    {
      "x": -113.4
    },
    {
      "x": -119.54
    },
    {
      "x": -125.66
    },
    {
      "x": -132.5
    },
    {
      "x": -138.56
    },
    {
      "x": -144.59
    },
    {
      "x": -151.35
    },
    {
      "x": -157.32
    },
    {
      "x": -163.27
    },
    {
      "x": -169.93
    },
    {
      "x": -175.82
    },
    {
      "x": -181.69
    },
    {
      "x": -188.25
    },
    {
      "x": -194.06
    },
    {
      "x": -200.57
    },
    {
      "x": -206.32
    },
    {
      "x": -212.05
    },
    {
      "x": -217.75
    },
    {
      "x": -224.13
    },
    {
      "x": -230.47
    },
    {
      "x": -236.09
    },
    {
      "x": -241.67
    },
    {
      "x": -247.24
    },
    {
      "x": -253.46
    },
    {
      "x": -258.96
    },
    {
      "x": -264.44
    },
    {
      "x": -269.89
    },
    {
      "x": -276
    },
    {
      "x": -281.39
    },
    {
      "x": -287.43
    },
    {
      "x": -292.77
    },
    {
      "x": -298.08
    },
    {
      "x": -303.37
    },
    {
      "x": -309.28
    },
    {
      "x": -314.51
    },
    {
      "x": -319.71
    },
    {
      "x": -325.54
    },
    {
      "x": -330.68
    },
    {
      "x": -335.8
    },
    {
      "x": -341.53
    },
    {
      "x": -346.6
    },
    {
      "x": -351.63
    },
    {
      "x": -357.27
    },
    {
      "x": -362.25
    },
    {
      "x": -367.2
    },
    {
      "x": -372.75
    },
    {
      "x": -377.65
    },
    {
      "x": -383.12
    },
    {
      "x": -387.97
    },
    {
      "x": -392.78
    },
    {
      "x": -398.17
    },
    {
      "x": -402.93
    },
    {
      "x": -407.66
    },
    {
      "x": -412.37
    },
    {
      "x": -417.63
    },
    {
      "x": -422.28
    },
    {
      "x": -427.48
    },
    {
      "x": -432.07
    },
    {
      "x": -436.64
    },
    {
      "x": -441.75
    },
    {
      "x": -446.26
    },
    {
      "x": -451.3
    },
    {
      "x": -455.76
    },
    {
      "x": -460.18
    },
    {
      "x": -464.59
    },
    {
      "x": -469.51
    },
    {
      "x": -473.85
    },
    {
      "x": -478.17
    },
    {
      "x": -482.46
    },
    {
      "x": -487.26
    },
    {
      "x": -492.02
    },
    {
      "x": -496.23
    },
    {
      "x": -500.41
    },
    {
      "x": -504.56
    },
    {
      "x": -509.2
    },
    {
      "x": -513.3
    },
    {
      "x": -517.37
    },
    {
      "x": -521.41
    },
    {
      "x": -525.93
    },
    {
      "x": -529.92
    },
    {
      "x": -534.37
    },
    {
      "x": -538.31
    },
    {
      "x": -542.21
    },
    {
      "x": -546.57
    },
    {
      "x": -550.42
    },
    {
      "x": -554.24
    },
    {
      "x": -558.51
    },
    {
      "x": -562.28
    },
    {
      "x": -566.02
    },
    {
      "x": -570.19
    },
    {
      "x": -573.87
    },
    {
      "x": -577.53
    },
    {
      "x": -581.61
    },
    {
      "x": -585.21
    },
    {
      "x": -588.79
    },
    {
      "x": -592.77
    },
    {
      "x": -596.29
    },
    {
      "x": -599.78
    },
    {
      "x": -603.68
    },
    {
      "x": -607.11
    },
    {
      "x": -610.52
    },
    {
      "x": -614.32
    },
    {
      "x": -617.67
    },
    {
      "x": -621
    },
    {
      "x": -624.71
    },
    {
      "x": -628.38
    },
    {
      "x": -631.62
    },
    {
      "x": -634.84
    },
    {
      "x": -638.02
    },
    {
      "x": -641.18
    },
    {
      "x": -644.71
    },
    {
      "x": -647.81
    },
    {
      "x": -650.89
    },
    {
      "x": -654.32
    },
    {
      "x": -657.34
    },
    {
      "x": -660.33
    },
    {
      "x": -663.67
    },
    {
      "x": -666.6
    },
    {
      "x": -669.52
    },
    {
      "x": -672.76
    },
    {
      "x": -675.61
    },
    {
      "x": -678.44
    },
    {
      "x": -681.59
    },
    {
      "x": -684.36
    },
    {
      "x": -687.45
    },
    {
      "x": -690.17
    },
    {
      "x": -692.86
    },
    {
      "x": -695.85
    },
    {
      "x": -698.48
    },
    {
      "x": -701.09
    },
    {
      "x": -703.67
    },
    {
      "x": -706.54
    },
    {
      "x": -709.07
    },
    {
      "x": -712.18
    },
    {
      "x": -714.65
    },
    {
      "x": -717.08
    },
    {
      "x": -719.5
    },
    {
      "x": -722.18
    },
    {
      "x": -724.53
    },
    {
      "x": -726.86
    },
    {
      "x": -729.16
    },
    {
      "x": -731.72
    },
    {
      "x": -733.96
    },
    {
      "x": -736.18
    },
    {
      "x": -738.38
    },
    {
      "x": -740.81
    },
    {
      "x": -742.95
    },
    {
      "x": -745.06
    },
    {
      "x": -747.4
    },
    {
      "x": -749.45
    },
    {
      "x": -751.73
    },
    {
      "x": -753.73
    },
    {
      "x": -755.7
    },
    {
      "x": -757.88
    },
    {
      "x": -759.8
    },
    {
      "x": -761.69
    },
    {
      "x": -763.78
    },
    {
      "x": -766.06
    },
    {
      "x": -772.24
    },
    {
      "x": -773.1
    },
    {
      "x": -817.98
    },
    {
      "x": -818.43
    },
    {
      "x": -818.7
    },
    {
      "x": -819.13
    },
    {
      "x": -819.8
    },
    {
      "x": -820.45
    },
    {
      "x": -821.14
    },
    {
      "x": -821.73
    },
    {
      "x": -822.3
    },
    {
      "x": -822.83
    },
    {
      "x": -823.4
    },
    {
      "x": -823.88
    },
    {
      "x": -824.34
    },
    {
      "x": -824.82
    },
    {
      "x": -825.21
    },
    {
      "x": -825.63
    },
    {
      "x": -826.01
    },
    {
      "x": -826.32
    },
    {
      "x": -826.61
    },
    {
      "x": -826.9
    },
    {
      "x": -827.1
    },
    {
      "x": -827.37
    },
    {
      "x": -827.52
    },
    {
      "x": -827.67
    },
    {
      "x": -827.79
    },
    {
      "x": -827.88
    },
    {
      "x": -827.95
    },
    {
      "x": -827.99
    }
  ],

  plane: [
    {
      "x": 0,
      "y": 0
    },
    {
      "x": 1.75,
      "y": -10.08
    },
    {
      "x": 1.92,
      "y": -11
    },
    {
      "x": 2.03,
      "y": -11.62
    },
    {
      "x": 2.41,
      "y": -13.77
    },
    {
      "x": 2.9,
      "y": -16.51
    },
    {
      "x": 3.38,
      "y": -19.22
    },
    {
      "x": 3.76,
      "y": -21.32
    },
    {
      "x": 4.25,
      "y": -23.99
    },
    {
      "x": 4.73,
      "y": -26.63
    },
    {
      "x": 5.11,
      "y": -28.67
    },
    {
      "x": 5.54,
      "y": -30.98
    },
    {
      "x": 6.02,
      "y": -33.55
    },
    {
      "x": 6.45,
      "y": -35.81
    },
    {
      "x": 6.87,
      "y": -38.06
    },
    {
      "x": 7.35,
      "y": -40.56
    },
    {
      "x": 7.83,
      "y": -43.04
    },
    {
      "x": 8.25,
      "y": -45.21
    },
    {
      "x": 8.68,
      "y": -47.37
    },
    {
      "x": 9.1,
      "y": -49.51
    },
    {
      "x": 9.57,
      "y": -51.89
    },
    {
      "x": 9.99,
      "y": -53.98
    },
    {
      "x": 10.41,
      "y": -56.06
    },
    {
      "x": 10.83,
      "y": -58.11
    },
    {
      "x": 11.3,
      "y": -60.4
    },
    {
      "x": 11.72,
      "y": -62.41
    },
    {
      "x": 12.13,
      "y": -64.4
    },
    {
      "x": 12.6,
      "y": -66.61
    },
    {
      "x": 13.01,
      "y": -68.55
    },
    {
      "x": 13.42,
      "y": -70.48
    },
    {
      "x": 13.89,
      "y": -72.62
    },
    {
      "x": 14.3,
      "y": -74.5
    },
    {
      "x": 14.71,
      "y": -76.36
    },
    {
      "x": 15.17,
      "y": -78.43
    },
    {
      "x": 15.58,
      "y": -80.25
    },
    {
      "x": 15.98,
      "y": -82.05
    },
    {
      "x": 16.44,
      "y": -84.04
    },
    {
      "x": 16.85,
      "y": -85.8
    },
    {
      "x": 17.25,
      "y": -87.53
    },
    {
      "x": 17.7,
      "y": -89.46
    },
    {
      "x": 18.11,
      "y": -91.15
    },
    {
      "x": 18.51,
      "y": -92.82
    },
    {
      "x": 18.96,
      "y": -94.67
    },
    {
      "x": 19.36,
      "y": -96.29
    },
    {
      "x": 19.76,
      "y": -97.9
    },
    {
      "x": 20.21,
      "y": -99.68
    },
    {
      "x": 20.6,
      "y": -101.24
    },
    {
      "x": 21,
      "y": -102.78
    },
    {
      "x": 21.44,
      "y": -104.49
    },
    {
      "x": 21.84,
      "y": -105.99
    },
    {
      "x": 22.23,
      "y": -107.47
    },
    {
      "x": 22.67,
      "y": -109.1
    },
    {
      "x": 23.06,
      "y": -110.54
    },
    {
      "x": 23.46,
      "y": -111.95
    },
    {
      "x": 23.89,
      "y": -113.52
    },
    {
      "x": 24.28,
      "y": -114.89
    },
    {
      "x": 24.67,
      "y": -116.24
    },
    {
      "x": 25.11,
      "y": -117.73
    },
    {
      "x": 25.49,
      "y": -119.03
    },
    {
      "x": 25.88,
      "y": -120.32
    },
    {
      "x": 26.31,
      "y": -121.74
    },
    {
      "x": 26.69,
      "y": -122.98
    },
    {
      "x": 27.12,
      "y": -124.35
    },
    {
      "x": 27.5,
      "y": -125.55
    },
    {
      "x": 27.89,
      "y": -126.73
    },
    {
      "x": 28.27,
      "y": -127.89
    },
    {
      "x": 28.69,
      "y": -129.16
    },
    {
      "x": 29.07,
      "y": -130.28
    },
    {
      "x": 29.45,
      "y": -131.37
    },
    {
      "x": 29.87,
      "y": -132.58
    },
    {
      "x": 30.24,
      "y": -133.63
    },
    {
      "x": 30.62,
      "y": -134.66
    },
    {
      "x": 31.04,
      "y": -135.79
    },
    {
      "x": 31.41,
      "y": -136.77
    },
    {
      "x": 31.78,
      "y": -137.74
    },
    {
      "x": 32.2,
      "y": -138.8
    },
    {
      "x": 32.57,
      "y": -139.72
    },
    {
      "x": 32.94,
      "y": -140.62
    },
    {
      "x": 33.35,
      "y": -141.61
    },
    {
      "x": 33.72,
      "y": -142.47
    },
    {
      "x": 34.08,
      "y": -143.31
    },
    {
      "x": 34.54,
      "y": -144.32
    },
    {
      "x": 34.9,
      "y": -145.12
    },
    {
      "x": 35.22,
      "y": -145.79
    },
    {
      "x": 35.63,
      "y": -146.64
    },
    {
      "x": 35.99,
      "y": -147.37
    },
    {
      "x": 36.35,
      "y": -148.08
    },
    {
      "x": 36.76,
      "y": -148.85
    },
    {
      "x": 37.11,
      "y": -149.51
    },
    {
      "x": 37.47,
      "y": -150.16
    },
    {
      "x": 37.87,
      "y": -150.86
    },
    {
      "x": 38.23,
      "y": -151.46
    },
    {
      "x": 38.58,
      "y": -152.04
    },
    {
      "x": 38.98,
      "y": -152.67
    },
    {
      "x": 39.34,
      "y": -153.21
    },
    {
      "x": 39.69,
      "y": -153.73
    },
    {
      "x": 40.08,
      "y": -154.28
    },
    {
      "x": 40.43,
      "y": -154.76
    },
    {
      "x": 40.78,
      "y": -155.21
    },
    {
      "x": 41.18,
      "y": -155.7
    },
    {
      "x": 41.52,
      "y": -156.11
    },
    {
      "x": 41.87,
      "y": -156.5
    },
    {
      "x": 42.26,
      "y": -156.91
    },
    {
      "x": 42.6,
      "y": -157.25
    },
    {
      "x": 42.95,
      "y": -157.58
    },
    {
      "x": 43.33,
      "y": -157.92
    },
    {
      "x": 43.68,
      "y": -158.2
    },
    {
      "x": 44.02,
      "y": -158.46
    },
    {
      "x": 44.4,
      "y": -158.73
    },
    {
      "x": 44.74,
      "y": -158.95
    },
    {
      "x": 45.08,
      "y": -159.15
    },
    {
      "x": 45.46,
      "y": -159.34
    },
    {
      "x": 45.79,
      "y": -159.5
    },
    {
      "x": 46.13,
      "y": -159.63
    },
    {
      "x": 46.51,
      "y": -159.76
    },
    {
      "x": 46.84,
      "y": -159.85
    },
    {
      "x": 47.21,
      "y": -159.92
    },
    {
      "x": 47.59,
      "y": -159.97
    },
    {
      "x": 47.88,
      "y": -159.99
    },
    {
      "x": 48.25,
      "y": -159.84
    },
    {
      "x": 48.58,
      "y": -159.2
    },
    {
      "x": 48.91,
      "y": -158.56
    },
    {
      "x": 49.27,
      "y": -157.85
    },
    {
      "x": 49.6,
      "y": -157.22
    },
    {
      "x": 49.93,
      "y": -156.58
    },
    {
      "x": 50.25,
      "y": -155.95
    },
    {
      "x": 50.62,
      "y": -155.25
    },
    {
      "x": 50.94,
      "y": -154.62
    },
    {
      "x": 51.26,
      "y": -154
    },
    {
      "x": 51.62,
      "y": -153.3
    },
    {
      "x": 51.94,
      "y": -152.68
    },
    {
      "x": 52.3,
      "y": -151.98
    },
    {
      "x": 52.62,
      "y": -151.36
    },
    {
      "x": 52.98,
      "y": -150.67
    },
    {
      "x": 53.29,
      "y": -150.06
    },
    {
      "x": 53.61,
      "y": -149.44
    },
    {
      "x": 53.92,
      "y": -148.83
    },
    {
      "x": 54.28,
      "y": -148.15
    },
    {
      "x": 54.59,
      "y": -147.54
    },
    {
      "x": 54.9,
      "y": -146.94
    },
    {
      "x": 55.25,
      "y": -146.26
    },
    {
      "x": 55.56,
      "y": -145.66
    },
    {
      "x": 55.91,
      "y": -144.98
    },
    {
      "x": 56.22,
      "y": -144.38
    },
    {
      "x": 56.52,
      "y": -143.79
    },
    {
      "x": 56.83,
      "y": -143.19
    },
    {
      "x": 57.17,
      "y": -142.53
    },
    {
      "x": 57.48,
      "y": -141.94
    },
    {
      "x": 57.78,
      "y": -141.35
    },
    {
      "x": 58.12,
      "y": -140.69
    },
    {
      "x": 58.42,
      "y": -140.1
    },
    {
      "x": 58.72,
      "y": -139.52
    },
    {
      "x": 59.02,
      "y": -138.94
    },
    {
      "x": 59.36,
      "y": -138.28
    },
    {
      "x": 59.66,
      "y": -137.7
    },
    {
      "x": 59.96,
      "y": -137.13
    },
    {
      "x": 60.29,
      "y": -136.48
    },
    {
      "x": 60.58,
      "y": -135.91
    },
    {
      "x": 60.88,
      "y": -135.34
    },
    {
      "x": 61.21,
      "y": -134.7
    },
    {
      "x": 61.5,
      "y": -134.13
    },
    {
      "x": 61.83,
      "y": -133.49
    },
    {
      "x": 62.12,
      "y": -132.93
    },
    {
      "x": 62.41,
      "y": -132.37
    },
    {
      "x": 62.7,
      "y": -131.81
    },
    {
      "x": 63.02,
      "y": -131.18
    },
    {
      "x": 63.31,
      "y": -130.62
    },
    {
      "x": 63.6,
      "y": -130.06
    },
    {
      "x": 63.92,
      "y": -129.44
    },
    {
      "x": 64.2,
      "y": -128.89
    },
    {
      "x": 64.49,
      "y": -128.34
    },
    {
      "x": 64.8,
      "y": -127.72
    },
    {
      "x": 65.12,
      "y": -127.11
    },
    {
      "x": 65.37,
      "y": -126.63
    },
    {
      "x": 65.68,
      "y": -126.02
    },
    {
      "x": 65.96,
      "y": -125.48
    },
    {
      "x": 66.24,
      "y": -124.94
    },
    {
      "x": 66.55,
      "y": -124.34
    },
    {
      "x": 66.82,
      "y": -123.8
    },
    {
      "x": 67.1,
      "y": -123.27
    },
    {
      "x": 67.41,
      "y": -122.67
    },
    {
      "x": 67.68,
      "y": -122.14
    },
    {
      "x": 67.99,
      "y": -121.54
    },
    {
      "x": 68.26,
      "y": -121.02
    },
    {
      "x": 68.53,
      "y": -120.49
    },
    {
      "x": 68.8,
      "y": -119.97
    },
    {
      "x": 69.1,
      "y": -119.38
    },
    {
      "x": 69.37,
      "y": -118.86
    },
    {
      "x": 69.64,
      "y": -118.34
    },
    {
      "x": 69.97,
      "y": -117.7
    },
    {
      "x": 70.2,
      "y": -117.25
    },
    {
      "x": 70.47,
      "y": -116.74
    },
    {
      "x": 70.76,
      "y": -116.16
    },
    {
      "x": 71.06,
      "y": -115.59
    },
    {
      "x": 71.32,
      "y": -115.08
    },
    {
      "x": 71.58,
      "y": -114.58
    },
    {
      "x": 71.84,
      "y": -114.07
    },
    {
      "x": 72.13,
      "y": -113.51
    },
    {
      "x": 72.48,
      "y": -112.82
    },
    {
      "x": 72.64,
      "y": -112.51
    },
    {
      "x": 72.93,
      "y": -111.95
    },
    {
      "x": 73.19,
      "y": -111.46
    },
    {
      "x": 73.47,
      "y": -110.9
    },
    {
      "x": 73.73,
      "y": -110.41
    },
    {
      "x": 73.98,
      "y": -109.92
    },
    {
      "x": 74.23,
      "y": -109.43
    },
    {
      "x": 74.51,
      "y": -108.89
    },
    {
      "x": 74.76,
      "y": -108.4
    },
    {
      "x": 75.01,
      "y": -107.92
    },
    {
      "x": 75.29,
      "y": -107.38
    },
    {
      "x": 75.53,
      "y": -106.9
    },
    {
      "x": 75.78,
      "y": -106.42
    },
    {
      "x": 76.06,
      "y": -105.89
    },
    {
      "x": 76.3,
      "y": -105.42
    },
    {
      "x": 76.54,
      "y": -104.94
    },
    {
      "x": 76.82,
      "y": -104.42
    },
    {
      "x": 77.06,
      "y": -103.95
    },
    {
      "x": 77.3,
      "y": -103.48
    },
    {
      "x": 77.57,
      "y": -102.96
    },
    {
      "x": 77.81,
      "y": -102.5
    },
    {
      "x": 78.04,
      "y": -102.04
    },
    {
      "x": 78.31,
      "y": -101.52
    },
    {
      "x": 78.54,
      "y": -101.06
    },
    {
      "x": 78.78,
      "y": -100.61
    },
    {
      "x": 79.04,
      "y": -100.1
    },
    {
      "x": 79.28,
      "y": -99.64
    },
    {
      "x": 79.51,
      "y": -99.19
    },
    {
      "x": 79.77,
      "y": -98.69
    },
    {
      "x": 80,
      "y": -98.24
    },
    {
      "x": 80.23,
      "y": -97.8
    },
    {
      "x": 80.48,
      "y": -97.3
    },
    {
      "x": 80.71,
      "y": -96.86
    },
    {
      "x": 80.94,
      "y": -96.42
    },
    {
      "x": 81.19,
      "y": -95.92
    },
    {
      "x": 81.42,
      "y": -95.49
    },
    {
      "x": 81.64,
      "y": -95.05
    },
    {
      "x": 81.89,
      "y": -94.57
    },
    {
      "x": 82.11,
      "y": -94.14
    },
    {
      "x": 82.33,
      "y": -93.71
    },
    {
      "x": 82.58,
      "y": -93.23
    },
    {
      "x": 82.8,
      "y": -92.8
    },
    {
      "x": 83.02,
      "y": -92.38
    },
    {
      "x": 83.26,
      "y": -91.9
    },
    {
      "x": 83.48,
      "y": -91.48
    },
    {
      "x": 83.7,
      "y": -91.06
    },
    {
      "x": 83.94,
      "y": -90.6
    },
    {
      "x": 84.15,
      "y": -90.18
    },
    {
      "x": 84.36,
      "y": -89.77
    },
    {
      "x": 84.6,
      "y": -89.31
    },
    {
      "x": 84.81,
      "y": -88.9
    },
    {
      "x": 85.05,
      "y": -88.44
    },
    {
      "x": 85.26,
      "y": -88.03
    },
    {
      "x": 85.47,
      "y": -87.63
    },
    {
      "x": 85.68,
      "y": -87.23
    },
    {
      "x": 85.91,
      "y": -86.78
    },
    {
      "x": 86.11,
      "y": -86.38
    },
    {
      "x": 86.32,
      "y": -85.98
    },
    {
      "x": 86.55,
      "y": -85.53
    },
    {
      "x": 86.75,
      "y": -85.14
    },
    {
      "x": 86.95,
      "y": -84.75
    },
    {
      "x": 87.18,
      "y": -84.31
    },
    {
      "x": 87.38,
      "y": -83.92
    },
    {
      "x": 87.58,
      "y": -83.54
    },
    {
      "x": 87.8,
      "y": -83.1
    },
    {
      "x": 88,
      "y": -82.72
    },
    {
      "x": 88.19,
      "y": -82.34
    },
    {
      "x": 88.41,
      "y": -81.91
    },
    {
      "x": 88.61,
      "y": -81.54
    },
    {
      "x": 88.82,
      "y": -81.11
    },
    {
      "x": 89.02,
      "y": -80.74
    },
    {
      "x": 89.21,
      "y": -80.37
    },
    {
      "x": 89.42,
      "y": -79.95
    },
    {
      "x": 89.61,
      "y": -79.58
    },
    {
      "x": 89.8,
      "y": -79.22
    },
    {
      "x": 89.99,
      "y": -78.85
    },
    {
      "x": 90.2,
      "y": -78.44
    },
    {
      "x": 90.39,
      "y": -78.08
    },
    {
      "x": 90.57,
      "y": -77.72
    },
    {
      "x": 90.78,
      "y": -77.32
    },
    {
      "x": 90.96,
      "y": -76.96
    },
    {
      "x": 91.15,
      "y": -76.61
    },
    {
      "x": 91.35,
      "y": -76.21
    },
    {
      "x": 91.53,
      "y": -75.86
    },
    {
      "x": 91.71,
      "y": -75.51
    },
    {
      "x": 91.91,
      "y": -75.12
    },
    {
      "x": 92.09,
      "y": -74.78
    },
    {
      "x": 92.27,
      "y": -74.43
    },
    {
      "x": 92.47,
      "y": -74.05
    },
    {
      "x": 92.64,
      "y": -73.71
    },
    {
      "x": 92.82,
      "y": -73.37
    },
    {
      "x": 93.01,
      "y": -72.99
    },
    {
      "x": 93.18,
      "y": -72.66
    },
    {
      "x": 93.35,
      "y": -72.32
    },
    {
      "x": 93.55,
      "y": -71.95
    },
    {
      "x": 93.72,
      "y": -71.62
    },
    {
      "x": 93.89,
      "y": -71.29
    },
    {
      "x": 94.07,
      "y": -70.93
    },
    {
      "x": 94.24,
      "y": -70.6
    },
    {
      "x": 94.41,
      "y": -70.28
    },
    {
      "x": 94.59,
      "y": -69.92
    },
    {
      "x": 94.76,
      "y": -69.6
    },
    {
      "x": 94.92,
      "y": -69.28
    },
    {
      "x": 95.1,
      "y": -68.93
    },
    {
      "x": 95.26,
      "y": -68.62
    },
    {
      "x": 95.43,
      "y": -68.3
    },
    {
      "x": 95.61,
      "y": -67.96
    },
    {
      "x": 95.76,
      "y": -67.65
    },
    {
      "x": 95.92,
      "y": -67.34
    },
    {
      "x": 96.1,
      "y": -67
    },
    {
      "x": 96.25,
      "y": -66.7
    },
    {
      "x": 96.41,
      "y": -66.4
    },
    {
      "x": 96.58,
      "y": -66.06
    },
    {
      "x": 96.74,
      "y": -65.76
    },
    {
      "x": 96.89,
      "y": -65.47
    },
    {
      "x": 97.06,
      "y": -65.14
    },
    {
      "x": 97.21,
      "y": -64.84
    },
    {
      "x": 97.36,
      "y": -64.55
    },
    {
      "x": 97.53,
      "y": -64.23
    },
    {
      "x": 97.67,
      "y": -63.94
    },
    {
      "x": 97.84,
      "y": -63.62
    },
    {
      "x": 97.98,
      "y": -63.34
    },
    {
      "x": 98.13,
      "y": -63.06
    },
    {
      "x": 98.29,
      "y": -62.74
    },
    {
      "x": 98.43,
      "y": -62.46
    },
    {
      "x": 98.58,
      "y": -62.19
    },
    {
      "x": 98.74,
      "y": -61.88
    },
    {
      "x": 98.88,
      "y": -61.61
    },
    {
      "x": 99.03,
      "y": -61.3
    },
    {
      "x": 99.17,
      "y": -61.03
    },
    {
      "x": 99.31,
      "y": -60.77
    },
    {
      "x": 100.28,
      "y": -58.88
    },
    {
      "x": 100.33,
      "y": -58.79
    },
    {
      "x": 100.43,
      "y": -58.6
    },
    {
      "x": 100.56,
      "y": -58.35
    },
    {
      "x": 100.7,
      "y": -58.07
    },
    {
      "x": 100.83,
      "y": -57.82
    },
    {
      "x": 100.96,
      "y": -57.57
    },
    {
      "x": 101.08,
      "y": -57.33
    },
    {
      "x": 101.21,
      "y": -57.09
    },
    {
      "x": 101.35,
      "y": -56.82
    },
    {
      "x": 101.47,
      "y": -56.58
    },
    {
      "x": 101.61,
      "y": -56.31
    },
    {
      "x": 101.73,
      "y": -56.07
    },
    {
      "x": 101.85,
      "y": -55.84
    },
    {
      "x": 101.97,
      "y": -55.61
    },
    {
      "x": 102.1,
      "y": -55.35
    },
    {
      "x": 102.22,
      "y": -55.12
    },
    {
      "x": 102.33,
      "y": -54.9
    },
    {
      "x": 102.46,
      "y": -54.64
    },
    {
      "x": 102.58,
      "y": -54.42
    },
    {
      "x": 102.69,
      "y": -54.2
    },
    {
      "x": 102.82,
      "y": -53.95
    },
    {
      "x": 102.93,
      "y": -53.74
    },
    {
      "x": 103.04,
      "y": -53.52
    },
    {
      "x": 103.17,
      "y": -53.28
    },
    {
      "x": 103.28,
      "y": -53.07
    },
    {
      "x": 103.4,
      "y": -52.83
    },
    {
      "x": 103.5,
      "y": -52.62
    },
    {
      "x": 103.61,
      "y": -52.42
    },
    {
      "x": 103.72,
      "y": -52.21
    },
    {
      "x": 103.83,
      "y": -51.98
    },
    {
      "x": 103.94,
      "y": -51.78
    },
    {
      "x": 104.04,
      "y": -51.58
    },
    {
      "x": 104.16,
      "y": -51.36
    },
    {
      "x": 104.27,
      "y": -51.14
    },
    {
      "x": 104.37,
      "y": -50.94
    },
    {
      "x": 104.47,
      "y": -50.75
    },
    {
      "x": 104.57,
      "y": -50.56
    },
    {
      "x": 104.66,
      "y": -50.37
    },
    {
      "x": 104.77,
      "y": -50.16
    },
    {
      "x": 104.87,
      "y": -49.98
    },
    {
      "x": 104.97,
      "y": -49.77
    },
    {
      "x": 105.07,
      "y": -49.59
    },
    {
      "x": 105.16,
      "y": -49.41
    },
    {
      "x": 105.25,
      "y": -49.23
    },
    {
      "x": 105.35,
      "y": -49.03
    },
    {
      "x": 105.44,
      "y": -48.86
    },
    {
      "x": 105.54,
      "y": -48.66
    },
    {
      "x": 105.63,
      "y": -48.49
    },
    {
      "x": 105.72,
      "y": -48.32
    },
    {
      "x": 105.82,
      "y": -48.13
    },
    {
      "x": 105.9,
      "y": -47.97
    },
    {
      "x": 105.99,
      "y": -47.8
    },
    {
      "x": 106.07,
      "y": -47.64
    },
    {
      "x": 106.16,
      "y": -47.46
    },
    {
      "x": 106.25,
      "y": -47.3
    },
    {
      "x": 106.33,
      "y": -47.14
    },
    {
      "x": 106.42,
      "y": -46.97
    },
    {
      "x": 106.5,
      "y": -46.8
    },
    {
      "x": 106.58,
      "y": -46.65
    },
    {
      "x": 106.66,
      "y": -46.5
    },
    {
      "x": 106.74,
      "y": -46.35
    },
    {
      "x": 106.82,
      "y": -46.18
    },
    {
      "x": 106.9,
      "y": -46.04
    },
    {
      "x": 106.97,
      "y": -45.9
    },
    {
      "x": 107.04,
      "y": -45.76
    },
    {
      "x": 107.12,
      "y": -45.6
    },
    {
      "x": 107.19,
      "y": -45.46
    },
    {
      "x": 107.27,
      "y": -45.31
    },
    {
      "x": 107.34,
      "y": -45.18
    },
    {
      "x": 107.42,
      "y": -45.03
    },
    {
      "x": 107.48,
      "y": -44.9
    },
    {
      "x": 107.55,
      "y": -44.77
    },
    {
      "x": 107.61,
      "y": -44.64
    },
    {
      "x": 107.68,
      "y": -44.52
    },
    {
      "x": 107.75,
      "y": -44.38
    },
    {
      "x": 107.81,
      "y": -44.26
    },
    {
      "x": 107.88,
      "y": -44.12
    },
    {
      "x": 107.94,
      "y": -44
    },
    {
      "x": 108,
      "y": -43.89
    },
    {
      "x": 108.07,
      "y": -43.76
    },
    {
      "x": 108.13,
      "y": -43.65
    },
    {
      "x": 108.18,
      "y": -43.54
    },
    {
      "x": 108.25,
      "y": -43.41
    },
    {
      "x": 108.3,
      "y": -43.31
    },
    {
      "x": 108.36,
      "y": -43.2
    },
    {
      "x": 108.42,
      "y": -43.08
    },
    {
      "x": 108.47,
      "y": -42.98
    },
    {
      "x": 108.52,
      "y": -42.88
    }
  ]
}
